import * as React from 'react';
import { useContext, useReducer, useState, useEffect } from "react";

import { MessagesContext } from "../common/context";
import { messagesReducer } from "../common/reducer";

import { TextField, initializeIcons } from "office-ui-fabric-react";
import { PrimaryButton, DefaultButton } from "office-ui-fabric-react/lib/Button";
import { MessageBar, MessageBarType, MessageBarButton} from 'office-ui-fabric-react';

import { useErrorBoundary } from "use-error-boundary";
import { validateEmail } from "../common/inputValidations";
import log from 'loglevel';


import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';

import { emailServiceSend } from "../../model/emailService";
import { getHtmlBodyStyles, getStyle, getTextBodyStyles, getFieldStyles, lineStyle} from "./ShareContainer.Styles";
import { EditorConvertToHTML} from "../editor/editorConvertToHTML";


import  * as uuidv4 from "uuid/v4";
import parse from "html-react-parser";
import { RENDER_FORMAT, CONTENT_TYPE } from "../common/consts";

export const ShareContainer = ({to, subject, header, footer,accessToken}) => {
  const { state , dispatch } = useContext(MessagesContext);
   
    const [recepients, setRecepients] = useState(state.emailTo);
    const [toValidation, setToValidation] = useState('');

    const [subjectText, setSubjectText] = useState(state.emailSubject);
    const [emailFrom, setEmailFrom] = useState(state.emailFrom);
    const [body, setBody] = useState('');
    
    const [renderFormat, setRenderFormat] = useState(RENDER_FORMAT.ParsedHtml);
    const [htmlChannelTemplate, setHtmlChannelTemplate] = useState('');
    const [htmlMessageTemplate, setHtmlMessageTemplate] = useState('');
    const [htmlReplyTemplate, setHtmlReplyTemplate] = useState('');
    const [rawHtmlBody, setRawHtmlBody] = useState('');
    const [parsedHtmlBody, setParsedHtmlBody] = useState();
    const [emailSent, setEmailSent] = useState(false);


    const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();
    log.info(` @ShareContainer`);
    log.debug(`@ShareContainer accessToken: ${accessToken}`);
  
    
    const _items= [
      {
        key: 'share',
        text: 'Send',
        iconProps: { iconName: 'Share' },
        //onClick={(event) => {handleSend(event,context);}} 
        onClick: (event) => handleSend(event,accessToken)
      }  ];

      const MyErrorComponent = ({error})=>{
        log.error(`error ${error.message}`);
        return (
        <div >error</div>
        )
      }
      
        
    const renderCommandBar = () => {
      log.info(` renderCommandBar @ ShareContainer`);
      return (
        <ErrorBoundary
          render={() => <CommandBar items={_items} />}
          renderError={({ error, errorInfo }) => (
            <MyErrorComponent error={error} />
          )}
        ></ErrorBoundary>
      )
    };

    //const stateItemsLength = state.messages.length;
    const stateItemsLength = state.selectedItems.length;
    const title = stateItemsLength > 0 ? `${stateItemsLength} Messages`
    : "No Items Selected!";

    //const itmText = `create a new component`;
    const getName = (user) =>  user ? user : 'Unknown';
    const messageDate = (date) => date ?  new Date(date).toString() : 'Undated';
    const getStyle = (type) => "text-align:left";
    const getItemUrl =(webUrl)=> webUrl ? webUrl : 'Empty';
    const getItemHtmlText =(text)=> text ? text : 'Empty';

    const getItemHtml = ({id,text,webUrl,user,date,type}) => `
    <div style="${getStyle(type)}" >
      <span style="${getStyle(type)}"><br/>Participant: <strong>${getName(user)}</strong> | <a
          href="${getItemUrl(webUrl)}"
          target="_blank"
          rel="noopener noreferrer"
      >Link to Post |</a> Posted on: ${messageDate(date)}: 
      </span><br/>${getItemHtmlText(text).trim()}
    </div>
    `;
    
    const getOpeningHtml = () => `
    <div  >      
      <p style="${getStyle(0)}">
       Date: ${new Date().toString()} 
       <strong>Meeting Notes: </strong>: 
        <br/>
      </p>
    </div>
    `;
    
   
   const validateFormInput = () => {
     log.info(`validateFormInput @ ShareContainer`);

     let _validated = true;

     let _toValidation = "";
     if (!validateEmail(recepients)) {
       _toValidation = "Error : invalid email address!";
       _validated = false;
     }
     setToValidation(_toValidation)
     return _validated;
   };

 /**
 * handleSend event handler to send email
 * @param event : the event object
 * @param _context  the sp context as the undelying object for ms graph 
 */ 
      const handleSend = (event, accessToken) => {
        log.info(` handleSend @ ShareContainer`);
        //const _body =   renderFormat == RENDER_FORMAT.Text ? body : state.bodyContent//rawHtmlBody

        if (validateFormInput()) {
          const _body = state.bodyContent;
          const _contentType = state.bodyContentType;

          try {
            emailServiceSend(
              recepients,
              subjectText,
              _body,
              _contentType,
              accessToken
            );
            setEmailSent(true);
          } catch (error) {
            log.error(
              ` catch / handleSend @ ShareContainer - error : ${JSON.stringify(
                error
              )}`
            );
            setEmailSent(false);
          } finally {
            log.info(` finally / handleSend @ ShareContainer`);
          }
        }
      };

      /**
       * Displays the content as text
       */
      const renderTextBody = () => {
        log.info(`renderTextBody @ ShareContainer`);
        return (
          <>
          <TextField
            value={state.bodyContent}
            multiline
            borderless
            autoAdjustHeight
            rows={1}
            styles={getTextBodyStyles}
          />
          </>
        );
      };
 
         
 /**
  * Displays the content as html after parsed into react components
  * 
  */
      const renderParsedHtmlBody = () => {
        log.info(`renderParsedHtmlBody @ ShareContainer`);
        return (
          <ErrorBoundary
            render={() => <div>{parse(state.bodyContent)}</div>}
            renderError={({ error, errorInfo }) => (
              <MyErrorComponent error={error} />
            )}
          ></ErrorBoundary>
        );
      };

    
/**
 * Edit receipients
 */
      const renderRecepients = () => {
        log.info(`renderRecepients @ ShareContainer`);
        
        const _toValidation =
        toValidation !== "" ? (
          <MessageBar
            isMultiline={false}
            messageBarType={MessageBarType.error}
            isMultiline={false}
            dismissButtonAriaLabel="Close"
            truncated={true}
            overflowButtonAriaLabel="See more"
            dismissButtonAriaLabel="Close"
          >
            {toValidation}
          </MessageBar>
        ) : (
          ""
        );

        return (
          <>
          <TextField
            placeholder="Recepients:"
            value={recepients}
            borderless
            autoAdjustHeight
            multiple
            styles={getFieldStyles}
            onChange={(event, newValue) => {
                setRecepients(newValue);
            }}
          />
          {_toValidation}
          </>
        );
      };
    

      /**
       * Edit the subject
       */
      const renderSubject = () => {
        log.info(`renderSubject @ ShareContainer`);                
        return (
          <>
          <TextField
            placeholder="Subject:"
            value={subjectText}
            borderless
            autoAdjustHeight
            styles={getFieldStyles}
            onChange={(event, newValue) => {
                setSubjectText(newValue);
            }}
          />
          </>
        );
      };

      const renderMessageBar = () => {
        log.info(`renderEmailSent @ ShareContainer`);
        if (emailSent) {
          return (
            <>
            <div style={lineStyle()}></div>
            <MessageBar
            isMultiline={false}
              messageBarType={MessageBarType.info}
              actions= { <MessageBarButton onClick = {()=>{setEmailSent(false)}}>Close</MessageBarButton> } >Email sent</MessageBar>
          </>
          );
        } else return <></>;
      };


      return (
        <>
            {renderCommandBar()}
            {renderMessageBar()}

            {renderRecepients()}
            {renderSubject()}
            {   // Renders the body content per provided format 
                state.bodyContentType == CONTENT_TYPE.TEXT ? renderTextBody() :
                state.bodyContentType == CONTENT_TYPE.HTML ? renderParsedHtmlBody() : 
                ''
            }
        </>
      )    
};






















    
    // useEffect(() => {
    //   if (renderFormat == RENDER_FORMAT.ParsedHtml) {
    //       let parsedHtmlItems = parse(state.)
    //       setParsedHtmlBody(parsedHtmlItems);
    //   }
    // },[renderFormat]);

  
    // useEffect(() => {

    //       //Reset the toggle value to be set again next time the user wants to push itsems to edito
    //         const _paylod = {
    //           loadSelectedItems: false 
    //         };
    //         dispatch({ type: "SET_EDIT_SELECTED_ITEMS", payload: _paylod });
    // },[]);


                {/* <PrimaryButton 
                onClick={(event) => {handleSend(event,context);}} 
                style={{ marginRight: "8px" }}> 
              Send Email
            </PrimaryButton> */}
